export const TELEMETRY_CONFIG__FETCH_CONFIG = 'TELEMETRY_CONFIG__FETCH_CONFIG';
export const TELEMETRY_CONFIG__FETCH_CONFIG_SUCCEEDED = 'TELEMETRY_CONFIG__FETCH_CONFIG_SUCCEEDED';
export const TELEMETRY_CONFIG__FETCH_CONFIG_FAILED = 'TELEMETRY_CONFIG__FETCH_CONFIG_FAILED';
